import axios from "axios";
import { invalidateSession } from "./sessionsActions";

////! UPDATE ENTIRE QUEUE JOBS
export const updateNotaryJobs = (userData) => {
  return {
    type: "UPDATE_NOTARY_JOBS",
    payload: userData,
  };
};
////! BROADCASTS INSERT ONE OJECT JOB INTO QUEUE
export const addJobToQueue = (queueData) => {
  return {
    type: "ADD_JOB_TO_QUEUE",
    payload: queueData,
  };
};
////! BROADCASTS REMOVE ONE OJECT JOB FROM QUEUE
export const removeJobFromQueue = (queueData) => {
  return {
    type: "REMOVE_JOB_FROM_QUEUE",
    payload: queueData,
  };
};
////! ADD ACCEPTED QUEUE JOB FROM QUEUE - PERSONAL
export const addAcceptedQueueJob = (queueData) => {
  return {
    type: "ADD_ACCEPTED_QUEUE_JOB",
    payload: queueData,
  };
};
////! REMOVE ACCEPTED QUEUE JOB - PERSONAL
export const removeAcceptedQueueJob = (queueData) => {
  return {
    type: "REMOVE_ACCEPTED_QUEUE_JOB",
    payload: queueData,
  };
};

export const addNotaryUser = (data) => {
  return {
    type: "ADD_NOTARY_USER_DATA",
    payload: data,
  };
};

export const updateNotaryUser = (data) => {
  return {
    type: "UPDATE_NOTARY_USER_DATA",
    payload: data,
  };
};

export const setExpiredExpeditedRequests = (data) => {
  return {
    type: "SET_EXPIRED_EXPEDITED_REQUESTS",
    payload: data,
  };
};

export const addRealTimeRequest = (data) => {
  return {
    type: "ADD_REAL_TIME_REQUEST",
    payload: data,
  };
};

export const setRealTimeRequests = (data) => {
  return {
    type: "SET_REAL_TIME_REQUESTS",
    payload: data,
  };
};

export const dismissRonRequest = (id) => {
  return {
    type: "DISMISS_RON_REQUEST",
    payload: id,
  };
};

export const dismissAllRonRequest = () => {
  return {
    type: "DISMISS_ALL_RON_REQUEST",
  };
};

export const navigateToRealRequestsTab = () => {
  return {
    type: "NAVIGATE_TO_REAL_REQUESTS_TAB",
  };
};

export const updateRequestCountdown = (requestId, timeRemaining) => {
  return {
    type: "UPDATE_REQUEST_COUNTDOWN",
    payload: { requestId, timeRemaining },
  };
};

export const removeExpiredRequest = (requestId) => {
  return {
    type: "REMOVE_EXPIRED_REQUEST",
    payload: requestId,
  };
};

export const setRealTimeRequestsFetched = (value) => {
  return {
    type: "SET_REAL_TIME_REQUESTS_FETCHED",
    payload: value,
  };
};

export const setExpiredRequestsFetched = (value) => {
  return {
    type: "SET_EXPIRED_REQUESTS_FETCHED",
    payload: value,
  };
};

export const fetchActiveRealTimeRequestsOnce =
  ({ force = false, currentSessionOverride = null } = {}) =>
  async (dispatch, getState) => {
    const state = getState();
    const currentSession =
      currentSessionOverride ||
      state?.sessions?.currentSession ||
      "notarySession";
    const notaryUser = state?.notarySession?.user;
    const alreadyFetched = !!state?.notarySession?.realTimeRequestsFetched;

    if (!force && alreadyFetched) {
      return { success: true, skipped: true };
    }

    if (!currentSession || !notaryUser?.notary_admin_id) {
      return { success: false, skipped: true };
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/nocApi/notary/active-real-time-requests`,
        {
          params: {
            currentSession,
            notary_admin_id: notaryUser.notary_admin_id,
          },
          withCredentials: true,
        },
      );

      const activeRequests = response?.data?.data || [];
      dispatch(setRealTimeRequests(activeRequests));

      dispatch(setRealTimeRequestsFetched(true));
      return { success: true, count: activeRequests.length };
    } catch (error) {
      return { success: false, error };
    }
  };

export const fetchExpiredExpeditedRequestsOnce =
  ({ force = false, currentSessionOverride = null } = {}) =>
  async (dispatch, getState) => {
    const state = getState();
    const currentSession =
      currentSessionOverride ||
      state?.sessions?.currentSession ||
      "notarySession";
    const notaryUser = state?.notarySession?.user;
    const alreadyFetched = !!state?.notarySession?.expiredRequestsFetched;

    if (!force && alreadyFetched) {
      return { success: true, skipped: true };
    }

    if (!currentSession || !notaryUser?.notary_admin_id) {
      return { success: false, skipped: true };
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/nocApi/notary/expired-expedited-requests`,
        {
          params: {
            currentSession,
            notary_admin_id: notaryUser.notary_admin_id,
          },
          withCredentials: true,
        },
      );

      dispatch(
        setExpiredExpeditedRequests(
          response?.data?.expired_expedited_requests || [],
        ),
      );
      dispatch(setExpiredRequestsFetched(true));

      return {
        success: true,
        count: (response?.data?.expired_expedited_requests || []).length,
      };
    } catch (error) {
      return { success: false, error };
    }
  };

export const fetchNotaryData = (sessionName) => async (dispatch, getState) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/auth/get-notary-user`,
      { sessionName: sessionName },
      { withCredentials: true },
    );

    // Dispatch the action to update user data

    dispatch(addNotaryUser(res.data));
    return res.data;
  } catch (error) {
    const { sessions } = getState();
    dispatch(invalidateSession(sessions.currentSession));
    return;
  }
};
